// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3omxf","social":"footer_social__2NWBC","copyright":"footer_copyright__3Sbm5"};